import React from 'react';

const ApproveStep = React.lazy(() => import("./approve"))

export default [
    { path: '/approval/steps/:id/approve', component: ApproveStep, name: 'Approvals' },
]

